import React from "react";

import styled from "styled-components/macro";

import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";
import Dropdown from "Signups/FamilyRegistration/Shared/Dropdown";
import ErrorMessage from "Signups/FamilyRegistration/Shared/ErrorMessage";
import RadioOption from "Signups/FamilyRegistration/Shared/RadioOption/RadioOption";
import useUpdateSetting from "Signups/FamilyRegistration/Shared/useUpdateSetting";
import { AnimatePresence, motion } from "framer-motion";

export default function GoToSignup({
  disabled,
  updatingRadioButtons,
  setUpdatingRadioButtons,
}) {
  const { state } = useFamilyRegistrationContext();
  const {
    updateSetting,
    saving,
    error,
    clearError: clearToggleError,
  } = useUpdateSetting();
  const {
    updateSetting: updateDropdown,
    error: dropdownError,
    clearError: clearDropdownError,
  } = useUpdateSetting();

  const enabled =
    state?.familyRegistrationSettings?.finishedActionSignup?.enabled;

  const options =
    state?.familyRegistrationSettings?.finishedActionSignup?.availableSignups;
  const selectedSignupID =
    state?.familyRegistrationSettings?.finishedActionSignup?.selectedSignupID;

  async function handleToggle() {
    if (updatingRadioButtons) return;
    clearDropdownError();
    setUpdatingRadioButtons(true);
    let postData = {
      setting: "finishedActionSignup",
      value: !enabled,
    };
    await updateSetting(postData);
    setUpdatingRadioButtons(false);
  }

  async function handleSelection(signupID) {
    clearToggleError();
    let postData = {
      setting: "finishedActionSignup",
      itemID: signupID,
    };
    await updateDropdown(postData);
  }

  return (
    <>
      <RadioOption
        selected={enabled}
        id={2}
        label="Take them to a Signup"
        onClick={handleToggle}
        loading={saving}
        disabled={disabled || (updatingRadioButtons && !saving)}
      >
        <AnimatePresence>
          {enabled && (
            <Content
              style={{ originY: "top" }}
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
            >
              <Dropdown
                placeholder="Select a Signup"
                options={options}
                onSelect={handleSelection}
                nameKey="signupTitle"
                idKey="signupID"
                initialSelectedId={selectedSignupID}
              />
            </Content>
          )}
        </AnimatePresence>
      </RadioOption>

      <ErrorMessage error={error?.error || dropdownError?.error} />
    </>
  );
}

const Content = styled(motion.div)`
  max-width: 360px;
  overflow: hidden;
`;
